"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";
declare global {
  interface Window {
    GoogleOneTap?: {
      enable: () => void;
      isEnabled: () => boolean;
      subscribe: typeof subscribeToGoogleOneTapConsent;
    };
  }
}
export const GOOGLE_ONE_TAP_SCRIPT_SRC = "https://accounts.google.com/gsi/client";
export const GOOGLE_ONE_TAP_CONSENT_GRANTED_EVENT = "google-one-tap-consent-granted";
let isGoogleOneTapConsentGranted = false;
const consentListeners = new Set<() => void>();
function notifyGoogleOneTapConsentListeners() {
  consentListeners.forEach(listener => listener());
  window.dispatchEvent(new Event(GOOGLE_ONE_TAP_CONSENT_GRANTED_EVENT));
}
function enableGoogleOneTapAfterConsent() {
  if (isGoogleOneTapConsentGranted) {
    return;
  }
  isGoogleOneTapConsentGranted = true;
  notifyGoogleOneTapConsentListeners();
}
function isGoogleOneTapEnabled() {
  return isGoogleOneTapConsentGranted;
}
function subscribeToGoogleOneTapConsent(listener: () => void) {
  consentListeners.add(listener);
  return () => {
    consentListeners.delete(listener);
  };
}
function registerGoogleOneTapConsentBridge() {
  if (window.GoogleOneTap) {
    return;
  }
  window.GoogleOneTap = {
    enable: enableGoogleOneTapAfterConsent,
    isEnabled: isGoogleOneTapEnabled,
    subscribe: subscribeToGoogleOneTapConsent
  };
}
export function resetGoogleOneTapConsentBridgeForTests() {
  isGoogleOneTapConsentGranted = false;
  consentListeners.clear();
  delete window.GoogleOneTap;
}
export default function GoogleOneTapConsentBridge() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  registerGoogleOneTapConsentBridge();
}